import { useState } from 'react';
import EmojiPicker from './EmojiPicker';
import { linkify } from '../../utils/linkify';

export default function TestiLikeComment({ testimonialId, initialLikes = 0, likesList = [], initialComments = [], currentUserId, token, apiBase = '/api/testimonials' }) {
  const [likes, setLikes] = useState(initialLikes);
  const [liked, setLiked] = useState(!!currentUserId && (likesList || []).some(id => String(id) === String(currentUserId)));
  const [comments, setComments] = useState(initialComments);
  const [showComments, setShowComments] = useState(false);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [reported, setReported] = useState([]);

  const handleLike = async () => {
    if (!token) return;
    const res = await fetch(apiBase + '/' + testimonialId + '/like', {
      method: 'PATCH',
      headers: { Authorization: 'Bearer ' + token }
    });
    if (res.ok) {
      const data = await res.json();
      setLikes(data.likes);
      setLiked(data.liked);
    }
  };

  const handleComment = async () => {
    if (!text.trim() || !token) return;
    setLoading(true);
    const res = await fetch(apiBase + '/' + testimonialId + '/comment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ text })
    });
    if (res.ok) {
      const newComment = await res.json();
      setComments(prev => [...prev, newComment]);
      setText('');
    }
    setLoading(false);
  };

  const handleReport = async (c, i) => {
    if (!token || reported.includes(i)) return;
    if (!window.confirm('Signaler ce commentaire ?')) return;
    try {
      await fetch('/api/reports', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({
          targetType: 'commentaire',
          targetId: c._id || testimonialId,
          context: testimonialId,
          targetLabel: (c.authorName || '') + ' : ' + (c.text || '').slice(0, 80)
        })
      });
      setReported(prev => [...prev, i]);
    } catch {}
  };

  return (
    <div onClick={e => e.stopPropagation()} style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #dccfc8' }}>
      <div style={{ display: 'flex', gap: 16, marginBottom: showComments && comments.length > 0 ? 10 : 0 }}>
        <button onClick={handleLike}
          style={{ background: 'none', border: 'none', fontSize: 13, color: liked ? '#8b1a2a' : '#9a8080', cursor: token ? 'pointer' : 'default', display: 'flex', alignItems: 'center', gap: 4, padding: 0 }}>
          {liked ? '♥' : '♡'} {likes} j'aime
        </button>
        <button onClick={() => setShowComments(!showComments)}
          style={{ background: 'none', border: 'none', fontSize: 13, color: '#9a8080', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, padding: 0 }}>
          {comments.length} commentaire{comments.length !== 1 ? 's' : ''}
        </button>
      </div>

      {showComments && (
        <div style={{ marginTop: 10 }}>
          {comments.filter(Boolean).map((c, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              {c.authorPhoto
                ? <img src={c.authorPhoto} alt="" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', border: '1px solid #c49090', flexShrink: 0 }} />
                : c.authorAvatar
                  ? <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#f5eeeb', border: '1px solid #c49090', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>{c.authorAvatar}</div>
                  : <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#f5eeeb', border: '1px solid #c49090', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#8b1a2a', flexShrink: 0 }}>{(c.authorName || 'A').slice(0,2).toUpperCase()}</div>}
              <div style={{ flex: 1, background: '#fafaf8', borderRadius: 8, padding: '6px 10px' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{c.authorName}</div>
                <div style={{ fontSize: 12, color: '#4a3030', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{linkify(c.text)}</div>
                {token && (reported.includes(i)
                  ? <span style={{ fontSize: 12, color: '#9a8080', display: 'inline-block', marginTop: 4 }}>Signalé</span>
                  : <span onClick={() => handleReport(c, i)} style={{ fontSize: 12, color: '#b08080', cursor: 'pointer', display: 'inline-block', marginTop: 4 }}>⚑ Signaler</span>)}
              </div>
            </div>
          ))}
          {token && (
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
              <input value={text} onChange={e => setText(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleComment()}
                placeholder="Ajouter un commentaire..."
                style={{ flex: 1, padding: '6px 12px', border: '1px solid #c49090', borderRadius: 20, fontSize: 12, background: '#fafaf8' }} />
              <EmojiPicker onEmojiClick={emoji => setText(prev => prev + emoji)} />
              <button onClick={handleComment} disabled={loading || !text.trim()}
                style={{ padding: '6px 14px', borderRadius: 20, border: 'none', background: text.trim() ? '#8b1a2a' : '#c49090', color: '#fff', fontSize: 12, cursor: 'pointer' }}>→</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
